import _ from "lodash";
import { ajax } from "../../app/core/ajax";
import { getLocalStorage, setLocalStorage } from "../core/core";

export const schemas: { [name: string]: any } = {};

export interface LoadSchemaJsonArgs {
    urlPrefix?: string;
    beforeSend?: (xhr, options) => any;
    headers?: { [key: string]: string };
}

export function loadSchemaJson(args?: LoadSchemaJsonArgs) {
    args = args || {};

    var deferred = $.Deferred();

    if (localStorage.schemas) {
        _.assign(schemas, $.parseJSON(getLocalStorage("schemas")));
        deferred.resolve();
    } else {
        ajax({
            cache: true,
            type: "GET",
            url: "SchemaJson",
            headers: args.headers,
            urlPrefix: args.urlPrefix,
            beforeSend: args.beforeSend
        }).done(function (data) {
            _.assign(schemas, data);
            deferred.resolve();
            try {
                setLocalStorage("schemas", JSON.stringify(schemas));
            } catch (e) {
                console.log(`error caching schemas: ${e}`);
            }
        }).fail(function (e) {
            deferred.reject(e);
        });
    }

    return deferred.promise();
}

/**
 * Examples:
 *
 * z.getSchemaProperty("Order.OrderNumber")
 * z.getSchemaProperty("Order.OrderSegment[0].OrderLine[0].Inventory.Description")
 * z.getSchemaProperty({ entity: "Site", property: "OwningCustomer.CustomerName" })
 *
 * Returns undefined if the property is not found in the schema.
 */
export function getSchemaProperty(args) {
    if (!args) {
        return undefined;
    }

    if ($.type(args) == "string") {
        args = {
            property: args
        };
    }

    if (!args.property) {
        return undefined;
    }

    args.schemas = args.schemas || schemas;

    var properties = args.property.split(".");
    properties = $.map(properties, function (p) {
        return p.indexOf("[") == -1
            ? p
            : p.substring(0, p.indexOf("["));
    });

    if (!args.entity) {
        args.entity = properties[0];
        properties = properties.slice(1);
    }

    var schema = args.schemas[args.entity];
    if (!schema) {
        return undefined;
    }

    for (var i = 0; i < properties.length - 1; i++) {
        var navigationProperty = schema.NavigationProperties[properties[i]];
        if (!navigationProperty || !navigationProperty.Type) {
            return undefined;
        }
        schema = args.schemas[navigationProperty.Type];
        if (!schema) {
            return undefined;
        }
    }

    return schema.Properties[properties[properties.length - 1]] || schema.NavigationProperties[properties[properties.length - 1]];
}
